import {Injectable,inject,signal} from '@angular/core';
import {AuthService} from './auth.service';
import {HttpClient} from '@angular/common/http';
import {firstValueFrom,filter} from 'rxjs';
import {Router,NavigationStart} from '@angular/router';
import {takeUntilDestroyed} from '@angular/core/rxjs-interop';
import {environment} from '../../../environments/environment';
@Injectable({providedIn:'root'})
export class PhoneVerificationService {
 private readonly http=inject(HttpClient);
 private readonly auth=inject(AuthService);
 private readonly router=inject(Router);
 constructor(){this.router.events.pipe(filter(event=>event instanceof NavigationStart),takeUntilDestroyed()).subscribe(()=>{if(this.pending())this.dismiss();});}
 private readonly url=environment.apiUrl+'/api/customers/phone-verification';
 readonly pending=signal(false);readonly busy=signal(false);readonly error=signal('');
 readonly challenge=signal<{id:string;channel:string;expiresAt:string}|null>(null);
 private resolve:((verified:boolean)=>void)|null=null;private version=0;
 async ensureVerified():Promise<boolean>{
  await firstValueFrom(this.auth.refreshCustomerProfile()).catch(()=>null);
  try{const status=await firstValueFrom(this.http.get<{verified:boolean}>(this.url+'/status'));if(status.verified)return true;}
  catch{this.error.set('No se pudo comprobar la verificación del teléfono.');return false;}
  if(this.pending())return false;
  this.version++;this.error.set('');this.challenge.set(null);this.pending.set(true);
  return new Promise(resolve=>this.resolve=resolve);
 }
 restart(){if(!this.busy()){this.challenge.set(null);this.error.set('');}}
 dismiss(){this.error.set('');this.version++;this.pending.set(false);this.busy.set(false);this.challenge.set(null);this.resolve?.(false);this.resolve=null;}
 async request(phone:string,smsOnly=false){
  if(this.busy()||!this.pending())return;this.busy.set(true);this.error.set('');const version=this.version;
  try{const challenge=await firstValueFrom(this.http.post<{id:string;channel:string;expiresAt:string}>(this.url+'/request',{phone,smsOnly}));if(version===this.version)this.challenge.set(challenge);}
  catch(e:any){if(version===this.version)this.error.set(e.status===429?'Espera antes de pedir otro código.':e.status===503?'No podemos enviar el SMS en este momento. Inténtalo más tarde.':'No se pudo enviar el código. Usa el teléfono con prefijo internacional.');}
  finally{if(version===this.version)this.busy.set(false);}
 }
 async verify(code:string){
  const challenge=this.challenge();if(!challenge||this.busy()||!this.pending())return;this.busy.set(true);this.error.set('');const version=this.version;
  try{await firstValueFrom(this.http.post(this.url+'/verify',{challengeId:challenge.id,code}));if(version===this.version){await firstValueFrom(this.auth.refreshCustomerProfile()).catch(()=>null);if(version!==this.version)return;this.pending.set(false);this.resolve?.(true);this.resolve=null;}}
  catch{if(version===this.version)this.error.set('Código incorrecto, caducado o ya utilizado.');}
  finally{if(version===this.version)this.busy.set(false);}
 }
}
